import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-screen">
      <div className="loading-terminal">
        <div className="terminal-header">
          <div className="header-dots">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
          <span className="header-text">STARTING UP</span>
        </div>
        <div className="terminal-content">
          <div className="progress-container">
            <div className="progress-bar"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
